import { gql } from 'apollo-angular';

// Test Case mutations — Go Lambda API
export const FDD_CREATE_TEST_CASE_MUTATION = gql`
  mutation createTestCase($data: String!) {
    createTestCase(data: $data)
  }
`;

export const FDD_UPDATE_TEST_CASE_MUTATION = gql`
  mutation updateTestCase($uid: String!, $data: String!) {
    updateTestCase(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_TEST_CASE_MUTATION = gql`
  mutation deleteTestCase($uid: String!) {
    deleteTestCase(uid: $uid)
  }
`;

export const FDD_SET_TEST_CASE_APPROVAL_MUTATION = gql`
  mutation setTestCaseApproval($uid: String!, $approval: String!) {
    setTestCaseApproval(uid: $uid, approval: $approval)
  }
`;

// Test Suite mutations — Go Lambda API
export const FDD_CREATE_TEST_SUITE_MUTATION = gql`
  mutation createTestSuite($data: String!) {
    createTestSuite(data: $data)
  }
`;

export const FDD_UPDATE_TEST_SUITE_MUTATION = gql`
  mutation updateTestSuite($uid: String!, $data: String!) {
    updateTestSuite(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_TEST_SUITE_MUTATION = gql`
  mutation deleteTestSuite($uid: String!) {
    deleteTestSuite(uid: $uid)
  }
`;

export const FDD_SET_TEST_SUITE_APPROVAL_MUTATION = gql`
  mutation setTestSuiteApproval($uid: String!, $approval: String!) {
    setTestSuiteApproval(uid: $uid, approval: $approval)
  }
`;

// Test Analysis mutations — Go Lambda API
export const FDD_CREATE_TEST_ANALYSIS_MUTATION = gql`
  mutation createTestAnalysis($data: String!) {
    createTestAnalysis(data: $data)
  }
`;

export const FDD_UPDATE_TEST_ANALYSIS_MUTATION = gql`
  mutation updateTestAnalysis($uid: String!, $data: String!) {
    updateTestAnalysis(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_TEST_ANALYSIS_MUTATION = gql`
  mutation deleteTestAnalysis($uid: String!) {
    deleteTestAnalysis(uid: $uid)
  }
`;

export const FDD_SET_TEST_ANALYSIS_APPROVAL_MUTATION = gql`
  mutation setTestAnalysisApproval($uid: String!, $approval: String!) {
    setTestAnalysisApproval(uid: $uid, approval: $approval)
  }
`;

// Test Specification mutations — Go Lambda API
export const FDD_CREATE_TEST_SPECIFICATION_MUTATION = gql`
  mutation createTestSpecification($data: String!) {
    createTestSpecification(data: $data)
  }
`;

export const FDD_UPDATE_TEST_SPECIFICATION_MUTATION = gql`
  mutation updateTestSpecification($uid: String!, $data: String!) {
    updateTestSpecification(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_TEST_SPECIFICATION_MUTATION = gql`
  mutation deleteTestSpecification($uid: String!) {
    deleteTestSpecification(uid: $uid)
  }
`;

export const FDD_SET_TEST_SPECIFICATION_APPROVAL_MUTATION = gql`
  mutation setTestSpecificationApproval($uid: String!, $approval: String!) {
    setTestSpecificationApproval(uid: $uid, approval: $approval)
  }
`;

// EESE coverage mutations — Go Lambda API (eesecoverage-lambda).
// createEeseCoverage stamps createdBy/modifiedBy/creationTime/modificationTime and an
// ESC-{n} itemNo server-side, so the client sends neither.
export const FDD_CREATE_EESE_COVERAGE_MUTATION = gql`
  mutation createEeseCoverage($data: String!) {
    createEeseCoverage(data: $data)
  }
`;

export const FDD_UPDATE_EESE_COVERAGE_MUTATION = gql`
  mutation updateEeseCoverage($uid: String!, $data: String!) {
    updateEeseCoverage(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_EESE_COVERAGE_MUTATION = gql`
  mutation deleteEeseCoverage($uid: String!) {
    deleteEeseCoverage(uid: $uid)
  }
`;

// Software version coverage mutations — Go Lambda API (softwareversioncoverage-lambda).
// Audit fields and an SWC-{n} itemNo are stamped server-side. ecuIds and softwareVersions
// are required, each with at least one entry.
// Specification coverage mutations — Go Lambda API (specificationcoverage-lambda).
// Audit fields and an SPC-{n} itemNo are stamped server-side.
export const FDD_CREATE_SPEC_COVERAGE_MUTATION = gql`
  mutation createSpecificationCoverage($data: String!) {
    createSpecificationCoverage(data: $data)
  }
`;

export const FDD_UPDATE_SPEC_COVERAGE_MUTATION = gql`
  mutation updateSpecificationCoverage($uid: String!, $data: String!) {
    updateSpecificationCoverage(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_SPEC_COVERAGE_MUTATION = gql`
  mutation deleteSpecificationCoverage($uid: String!) {
    deleteSpecificationCoverage(uid: $uid)
  }
`;

export const FDD_CREATE_SW_VERSION_COVERAGE_MUTATION = gql`
  mutation createSoftwareVersionCoverage($data: String!) {
    createSoftwareVersionCoverage(data: $data)
  }
`;

export const FDD_UPDATE_SW_VERSION_COVERAGE_MUTATION = gql`
  mutation updateSoftwareVersionCoverage($uid: String!, $data: String!) {
    updateSoftwareVersionCoverage(uid: $uid, data: $data)
  }
`;

export const FDD_DELETE_SW_VERSION_COVERAGE_MUTATION = gql`
  mutation deleteSoftwareVersionCoverage($uid: String!) {
    deleteSoftwareVersionCoverage(uid: $uid)
  }
`;
